export enum ConstantsLDP {
  MoveUpDuration = 5,
  FreeMoveUpDuration = 15,
}
